'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisPrefixUrl)(feis_id) + '/events/' + event_id + '/adjudicators/' + adj_id + '/scores',
        method: 'DELETE'
      },
      types: ['DELETE_EVENT_SCORES_BY_ADJUDICATOR_START', 'DELETE_EVENT_SCORES_BY_ADJUDICATOR', 'DELETE_EVENT_SCORES_BY_ADJUDICATOR_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scores/deleteEventScoresByAdjudicator.js
// module id = 240
// module chunks = 0